var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.hasSection
    ? _c(
        "section",
        {
          staticClass: "lpu-prices d-flex flex-column",
          class: _setup.isMobile ? "ga-4" : "ga-6",
          attrs: { id: "prices", "data-qa": "lpu_prices" },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-column",
              class: { "ga-4": _setup.appointmentPhone },
            },
            [
              _c(
                "h2",
                {
                  staticClass: "text--text",
                  class: _setup.isMobile ? "text-h6" : "text-h5",
                  attrs: { "data-qa": "lpu_prices_title" },
                },
                [_vm._v("\n      " + _vm._s(_setup.tStatic("Цены")) + "\n    ")]
              ),
              _vm._v(" "),
              _setup.appointmentPhone
                ? _c("div", { staticClass: "d-flex align-center ga-3" }, [
                    _c(
                      "span",
                      { staticClass: "text-body-1 text-secondary--text" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.tStatic("Запись на приём:")) +
                            "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "d-flex align-center ga-2" }, [
                      _c("span", {
                        staticClass:
                          "ui-icon-ui-call ui-icon-fz-smaller flex-shrink-0 text-lpu-branding-color-primary",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-body-1 font-weight-medium text--text",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.appointmentPhone) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _setup.hasSynonymPrices
            ? _c(_setup.PricesServiceList, {
                attrs: {
                  services: _setup.services,
                  "show-all-href": _setup.synonymShowAllHref,
                  "lpu-id": _vm.lpu.id,
                  "town-timedelta": _setup.townTimedelta,
                },
                on: {
                  "empty-schedule": _setup.onEmptySchedule,
                  slot: _setup.onSlotClick,
                },
              })
            : _c(_setup.PricesRangeList, {
                attrs: {
                  items: _setup.ranges,
                  "prices-path": _setup.pricesPath,
                  "show-all-href": _setup.rangeShowAllHref,
                },
              }),
          _vm._v(" "),
          _setup.isClientMounted && _setup.hasSynonymPrices
            ? _c(_setup.InvasiveServiceInfo)
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }